import reducer from "./reducer";
export { default as Feed } from "./components/index";
export { default as feedReducerName } from "./constants";
export default reducer;
